import {
  createPathCompiler,
  createPathParamsHook,
  createPathResolver,
} from './utils'

export const pathFragmentRecord = {
  appRoot: '/:appRootPath',
  brandAccountFragment: '/brandaccounts/:brandAccountId',
  surveyFragment: '/surveys/:surveyId',
  brandGroupFragment: '/brandgroups/:brandGroupId',
} as const

const pathRecord = {
  top: '/',
  restore: '/to/:key',
  appRoot: `${pathFragmentRecord.appRoot}/*`,
} as const

type PathRecord = typeof pathRecord
export type PathKey = keyof PathRecord
export type PathValue = ValueOf<PathRecord>
export type PathParams<Key extends PathKey> = AnalyzePathParams<PathRecord[Key]>

export const usePathParams = createPathParamsHook(pathRecord)
export const compile = createPathCompiler(pathRecord)
export const resolve = createPathResolver(pathRecord)
